module.exports = __webpack_public_path__ + "img/cnCover.d4bb2ecb.png";